import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const projectApi = createApi({
  reducerPath: "projectApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "services/service-requests",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token"); // ✅ or from redux state
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getProjects: builder.mutation({
      query: (query = {}) => {
        const {
          sort= '-createdAt',
          filter,
          page = 1,
          limit = 10,
          search,
          area,
          category,
        } = query;
        let url = "/related?";
        const payload = { area };


        if (page) {
          url += `page=${page}`;
        }

        if (limit) {
          url += `&limit=${limit}`;
        }

        if (filter) {
          url += `&${filter}`;
        }
        if (category) {
          url += `&category=${category}`;
        }

        if (sort) {
          url += `&sort=${sort}`;
        }

        if (search) {
          url += `&search=${search}`;
        }


        return {
          url: url,
          method: "POST",
          body: payload,
        };
      },
    }),
    getProjectsHomePage: builder.query({
      query: (query = {}) => {
        const { sort, filter, page = 1, limit = 20, search, area } = query;
        let url = "/home?";
        const payload = { area };


        if (page) {
          url += `page=${page}`;
        }

        if (limit) {
          url += `&limit=${limit}`;
        }

        if (filter) {
          url += `&${filter}`;
        }

        if (sort) {
          url += `&sort=${sort}`;
        }

        if (search) {
          url += `&search=${search}`;
        }


        return {
          url: url,
          method: "Get",
        };
      },
    }),
  }),
});

export const { useGetProjectsMutation, useGetProjectsHomePageQuery } =
  projectApi;
